//import react
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { Card, CardActions, CardText } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import { cyan500, pinkA200 } from 'material-ui/styles/colors';
import { Link } from 'react-router-dom';
import { Notification, translate, userLogin as userLoginAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import { userRegister as userRegisterAction, userForgotpass as  userForgotpassAction } from './AuthActionAddons';

import CheckIcon from 'material-ui/svg-icons/action/check-circle';


import FlatButton from 'material-ui/FlatButton';
const required = value => value ? undefined : 'Verplicht'
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Ongelidig e-mailadres' : undefined
 
const minLength = min => value =>
  value && value.length < min ? `Moet minimaal ${min} karakters bevatten` : undefined

const minLength8 = minLength(8)

//allow a-z0-9 and dash (-) and backslash (\\) and forward slash (\/): [a-z0-9\-\\\/]
const website = value => value && !/^(http\:\/\/|https\:\/\/)+([a-z0-9][a-z0-9\-]*\.)+[a-z0-9\-\\\/]*$/i.test(value) ?
  'Ongeldig website adres' : undefined

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
    },
    card: {
        width: 400,
    },
    avatar: {
        margin: '1em',
        textAlign: 'center ',
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        display: 'flex',
    },
    hint: {
        textAlign: 'center',
        marginTop: '1em',
		marginBottom: '0.3em',
        color: '#999',
		fontSize: '130%',
    },
	loginWidth: {
		width: 400,	
		marginTop: '5px',
		marginBottom: '5px',
		fontSize: '110%',
		color: '#6f6f6f',
		lineHeight: '25px',
	},
	flatButton: {
		color: '#284263',
		fontWeight: 'bold',
		fontSize: '115%',
	},
	checkIcon: {
		width: 18,
		height: 18,	
		verticalAlign: 'middle',
		paddingBottom: '4px',
		color: '#284263',
	},
	checkSpan: {
		display: 'block',	
	},
	h2: {
		margin: '0',
		padding: '4px 0px',	
		color: '#284263',
	},
	cardText: {
		lineHeight: '22px',	
		background: '#fff',
		borderRadius: '2px',
		padding: '10px',
		marginTop: '25px',
		width: 400,
		boxSizing: 'border-box',
	},
	forgotPass: {
		marginTop: '5px',
		opacity: '0.8',	
	},
	floatingLabel: {
		color: '#999',
	},
	registerBtn: {
		marginTop: '8px',
		marginBottom: '5px',			
	}
	
};

function getColorsFromTheme(theme) {
    if (!theme) return { primary1Color: cyan500, accent1Color: pinkA200 };
    const {
        palette: {
            primary1Color,
            accent1Color,
        },
      } = theme;
    return { primary1Color, accent1Color };
}

function gup( name, url ) {
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? null : results[1];
}

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({ meta: { touched, error } = {}, input: { ...inputProps }, ...props }) =>
    <TextField
        errorText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />;

class Login extends Component {

    login = ({ username, password }) => {
        const { userLogin, location } = this.props;
        userLogin({ username, password }, location.state ? location.state.nextPathname : '/');
    }
	
	register = ({ email, password, company_name, company_site }) => {
        const { userRegister, location } = this.props;
		this.setState({actionSubmitting: true});	
        userRegister({ email, password, company_name, company_site }, location.state ? location.state.nextPathname : '/');
		
		var parent = this;
		setTimeout(function(){ parent.setState({actionSubmitting: false}); }, 10000); //10 secs
    }
	
	forgotpass = ({ email }) => {
		this.setState({actionSubmitting: true});
        const { userForgotpass, location } = this.props;
        userForgotpass({ email }, location.state ? location.state.nextPathname : '/');
		
		var parent = this;
		setTimeout(function(){ parent.setState({actionSubmitting: false}); }, 2500); //2,5secs
		
    }
	
	constructor(props){
	    super(props);
    	this.state = { 
			showRegistration : false,
			showForgotPass: false,
			actionSubmitting: false,
		};
  	}
	
    showRegistration = (e) => {		
		e.preventDefault();
       	this.setState({showRegistration:!this.state.showRegistration});	
		
	
    }
	
	showLogin = (e) => {
		const { push } = this.props;		
		e.preventDefault();
       	push('/login')
		this.setState({showForgotPass:false, showRegistration:false});		
		
    }
	
	showForgotPass = (e) => {		
		e.preventDefault();
       	this.setState({showForgotPass:!this.state.showForgotPass, showRegistration:false});		
    }
	

    render() {
        const { handleSubmit, submitting, theme, translate } = this.props;
        const muiTheme = getMuiTheme(theme);
        const { primary1Color, accent1Color } = getColorsFromTheme(muiTheme);
       		
		if(this.state.showForgotPass === true) { 
			return (
				<MuiThemeProvider muiTheme={muiTheme}>
					<div style={{ ...styles.main, backgroundColor: primary1Color }}>
						<Card style={styles.card}>
							<div style={styles.avatar}>
								<Avatar backgroundColor={accent1Color} icon={<LockIcon />} size={60} />								
							</div>
							<form onSubmit={handleSubmit(this.forgotpass)}>
								<p style={styles.hint}>Wachtwoord vergeten</p>
								<div style={styles.form}>
									<div style={styles.input} >
										<Field
											name="email"
											component={renderInput}
											floatingLabelText={translate('aor.auth.email')}
											validate={[ required, email ]}
										/>
									</div>
								</div>
								<CardActions>
									  <RaisedButton type="submit" primary disabled={this.state.actionSubmitting} label={translate('cloudhints.request_new_pass')} fullWidth />
									  
									  <FlatButton style={styles.forgotPass} label={translate('cloudhints.back_to_login')} fullWidth={true} onClick={this.showLogin} />
								</CardActions>	
								
							</form>
						</Card>
						<Notification />
					</div>
				</MuiThemeProvider>
			);
		} else if(this.state.showRegistration === true || gup('show',window.location.href) === 'register') { 
			return (
				<MuiThemeProvider muiTheme={muiTheme}>
					<div style={{ ...styles.main, backgroundColor: primary1Color }}>
						<Card style={styles.card}>
							<div style={styles.avatar}>
								<Avatar backgroundColor={accent1Color} icon={<LockIcon />} size={60} />								
							</div>
							<form onSubmit={handleSubmit(this.register)}>
								<p style={styles.hint}>Registreren</p>
								<div style={styles.form}>
									<div style={styles.input} >
										<Field
											name="email"
											component={renderInput}
											floatingLabelText={translate('aor.auth.email')}
											validate={[ required, email ]}
										/>
									</div>
									<div style={styles.input} >
										<Field
											name="company_name"
											component={renderInput}
											floatingLabelText={translate('aor.auth.company_name')}
											validate={[ required ]}
										/>
									</div>
									<div style={styles.input} >
										<Field
											name="company_site"
											component={renderInput}
											floatingLabelText={translate('aor.auth.company_site')}
											validate={[ required, website ]}
										/>
									</div>
									<div style={styles.input}>
										<Field
											name="password"
											component={renderInput}
											floatingLabelText={translate('aor.auth.password')}
											type="password"
											validate={[ required, minLength8 ]}
										/>
									</div>
								</div>
								<CardActions>
									  <RaisedButton type="submit" primary disabled={this.state.actionSubmitting} label={translate('aor.auth.sign_up')} fullWidth />
									  
									  <FlatButton style={styles.forgotPass} label={translate('cloudhints.back_to_login')} fullWidth={true} onClick={this.showLogin} />
								</CardActions>	
							</form>
						</Card>
						<CardText style={styles.cardText}>
								<h2 style={styles.h2}>Voordelen van een account</h2>
								<p style={styles.loginWidth}>Registreer nu voor een gratis account. 
									<span style={styles.checkSpan}><CheckIcon style={styles.checkIcon} /> Gratis plaatsing op diverse vergelijkingssites.</span>
									<span style={styles.checkSpan}><CheckIcon style={styles.checkIcon} /> Zelf plaatsingen en biedingen (CPC) beheren.</span>
								</p>								
						</CardText>
						<Notification />
					</div>
				</MuiThemeProvider>
			);
		} else {
			return (
				<MuiThemeProvider muiTheme={muiTheme}>
					<div style={{ ...styles.main, backgroundColor: primary1Color }}>
						<Card style={styles.card}>
							<div style={styles.avatar}>
								<Avatar backgroundColor={accent1Color} icon={<LockIcon />} size={60} />
							</div>
							<form onSubmit={handleSubmit(this.login)} >
								<p style={styles.hint}>Inloggen</p>
								<div style={styles.form}>
									<div style={styles.input} >
										<Field
											name="username"
											component={renderInput}
											floatingLabelText={translate('aor.auth.email')}
											validate={[ required, email ]}
											floatingLabelStyle={styles.floatingLabel}
										/>
									</div>
									<div style={styles.input}>
										<Field
											name="password"
											component={renderInput}
											floatingLabelText={translate('aor.auth.password')}
											type="password"
											validate={[ required ]}
											floatingLabelStyle={styles.floatingLabel}											
										/>
									</div>
								</div>
								<CardActions>											
										<RaisedButton type="submit" primary disabled={submitting} label={translate('aor.auth.sign_in')} fullWidth />	
										
										<FlatButton style={styles.forgotPass} label={translate('cloudhints.forgot_pass')} fullWidth={true} onClick={this.showForgotPass} />										
								</CardActions>
							</form>
						</Card>
						<CardText style={styles.cardText}>
								<h2 style={styles.h2}>Nog geen account?</h2>
								<p style={styles.loginWidth}>Registreer nu voor een gratis account. 
									<span style={styles.checkSpan}><CheckIcon style={styles.checkIcon} /> Gratis plaatsing op diverse vergelijkingssites.</span>
									<span style={styles.checkSpan}><CheckIcon style={styles.checkIcon} /> Zelf plaatsingen en biedingen (CPC) beheren.</span>
								</p>
								<div>
									<RaisedButton primary style={styles.registerBtn} label={translate('cloudhints.new_account')} fullWidth onClick={this.showRegistration} />
								</div>
						</CardText>
						<Notification />
					</div>
					
								
				</MuiThemeProvider>
			);
		}
    }
}

Login.propTypes = {
    ...propTypes,
    authClient: PropTypes.func,
    previousRoute: PropTypes.string,
    theme: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
	push: PropTypes.func,
};

Login.defaultProps = {
    theme: {},
};

const enhance = compose(
    translate,
    reduxForm({
        form: 'signIn',
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            if (!values.username) errors.username = translate('aor.validation.required');
            if (!values.password) errors.password = translate('aor.validation.required');
            return errors;
        },
    }),
    connect(null, { push: pushAction, userLogin: userLoginAction, userRegister: userRegisterAction, userForgotpass: userForgotpassAction }),
);

export default enhance(Login);


// WEBPACK FOOTER //
// ./src/login.js